import FeatureLayerProperties = __esri.FeatureLayerProperties

export const layerProps: FeatureLayerProperties = {
	id: 'SewerWorkZones',
	minScale: 50000
}
